import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';

const ClientDashboardPage = () => {
  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        {/* Header */}
        <div className="mb-4">
          <Row className="align-items-center">
            <Col>
              <h2 className="mb-2">
                <FontAwesomeIcon icon="user-tie" className="me-2 text-primary" />
                Dashboard de Clientes
              </h2>
              <h5 className="text-700 fw-semi-bold">
                Vista general de la performance de tus clientes
              </h5>
            </Col>
          </Row>
        </div>

        {/* Estadísticas rápidas */}
        <Row className="g-3 mb-4">
          <Col lg={3} md={6}>
            <Card className="bg-primary text-white">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="text-white mb-0">125</h4>
                    <small>Clientes Activos</small>
                  </div>
                  <FontAwesomeIcon icon="users" size="2x" className="opacity-50" />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6}>
            <Card className="bg-success text-white">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="text-white mb-0">$2.4M</h4>
                    <small>Inversión Total</small>
                  </div>
                  <FontAwesomeIcon icon="dollar-sign" size="2x" className="opacity-50" />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6}>
            <Card className="bg-info text-white">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="text-white mb-0">89%</h4>
                    <small>Retención</small>
                  </div>
                  <FontAwesomeIcon icon="chart-line" size="2x" className="opacity-50" />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6}>
            <Card className="bg-warning text-white">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="text-white mb-0">4.2</h4>
                    <small>ROAS Promedio</small>
                  </div>
                  <FontAwesomeIcon icon="chart-bar" size="2x" className="opacity-50" />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Contenido principal */}
        <Card className="shadow-sm">
          <FalconCardHeader title="Dashboard de Clientes" />
          <Card.Body>
            <div className="text-center py-5">
              <FontAwesomeIcon icon="user-tie" size="3x" className="text-muted mb-3" />
              <h5>Dashboard de Clientes</h5>
              <p className="text-muted">
                Aquí podrás ver métricas detalladas de todos tus clientes, 
                incluyendo performance, inversión y ROI.
              </p>
              <p className="text-muted">
                <strong>Funcionalidades disponibles:</strong>
              </p>
              <ul className="list-unstyled text-muted">
                <li>📊 Métricas de performance por cliente</li>
                <li>💰 Análisis de inversión y ROI</li>
                <li>📈 Tendencias y comparativas</li>
                <li>🎯 Objetivos y metas</li>
                <li>📄 Reportes personalizados</li>
              </ul>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default ClientDashboardPage; 